import React from "react";

export interface StatisticListProps {
  title: string;
  details: {
    percentage: number;
    text: string;
    source: string;
    showItem: boolean;
  }[];
  titleFontClass?: string;
  descriptionFontClass?: string;
  percentageFontClass?: string;
  sourceFontClass?: string;
  containerClass?: string;
}

export default function StatisticList({
  title,
  details,
  titleFontClass = "",
  descriptionFontClass = "",

  percentageFontClass = "",
  sourceFontClass = "",
  containerClass = "",
}: StatisticListProps) {
  return (
    <div className={`flex flex-col gap-10 ${containerClass}`}>
      <h2
        className={`my-0 text-white italic font-black md:text-4xl tracking-[-0.06rem] text-3xl ${titleFontClass}`}
      >
        {title}
      </h2>
      <ul className={`flex flex-col gap-4 text-white`}>
        {details
          .filter((item) => item.showItem)
          .map((item, index) => (
            <li key={index} className="flex flex-col">
              <div className="flex flex-col items-start sm:flex-row sm:gap-6">
                <span
                  className={`text-[52px] text-white italic font-black leading-[100%] tracking-[-0.02em] ${percentageFontClass}`}
                >
                  {item.percentage}%
                </span>

                <p
                  className={`text-[16px] font-normal text-white mb-2 ${descriptionFontClass}`}
                >
                  {item.text}
                </p>
              </div>
              <span
                className={`text-[11px] font-normal italic text-white ${sourceFontClass}`}
              >
                {item.source}
              </span>
            </li>
          ))}
      </ul>
    </div>
  );
}
